// @ts-check

import angular from 'angular';

/**
 * RcmJsLib Module
 */
angular.module('RcmJsLib', []);
